import { createClient } from "next-sanity";

const clientConfig = {
  dataset: process.env.NEXT_PUBLIC_SANITY_STUDIO_API_DATASET,
  projectId: process.env.NEXT_PUBLIC_SANITY_STUDIO_API_PROJECT_ID,
  token: process.env.SANITY_READ_TOKEN,
  apiVersion: "2021-10-21",
  useCdn: false,
};

const sanityClient = createClient(clientConfig);

const previewClientConfig = {
  dataset: process.env.NEXT_PUBLIC_SANITY_STUDIO_API_DATASET,
  projectId: process.env.NEXT_PUBLIC_SANITY_STUDIO_API_PROJECT_ID,
  token: process.env.SANITY_PREVIEW_TOKEN,
  useCdn: false,
  apiVersion: "2021-10-21",
  documentLimit: 10000,
};

const previewClient = createClient(previewClientConfig);

const getClient = (preview = false) => (preview ? previewClient : sanityClient);

export { getClient, previewClientConfig, clientConfig };
